import React, { useState, useEffect } from 'react'
import './OurProducts.scss'
import { Link } from 'react-router-dom'

import 'aos/dist/aos.css'
import Aos from 'aos'

import { useNavigate } from 'react-router-dom'

import LazyLoad from 'react-lazy-load'

export default function OurProducts() {
  const [text, setText] = useState(false)

  const navigation = useNavigate()

  const ourProductHandler = () => {
    setText(true)
  }

  useEffect(() => {
    Aos.init({ duration: 2500, once: true })
  }, [])

  return (
    <div className='ourProducts' data-aos= 'fade-right'>
      <LazyLoad height={500} offset={300}>
        <div className="ourProducts_image">
        </div>
      </LazyLoad>
      <div className='container'>
        <div className='row'>
          <div className="ourProducts_contents">
            <div className="ourProducts_contents_title">
              ANA FAALİYETLERİMİZ 
            </div>
            <div className="ourProducts_contents_subtitle">
              <div style={text ? { display: 'none' } : { display: '' }}>
                Global Enerji Yatırım ve ortağının lider şirketleri, Çelik Sanayi, İnşaat, MSW tesisi, geri dönüşüm ve atıklardan enerji santraline kadar sektörde faaliyet göstermektedir. <br /><Link onClick={ourProductHandler}>read more ...</Link>
              </div>
              <div style={text ? { display: '' } : { display: 'none' }}>
                Global Enerji Yatırım ve ortağının lider şirketleri Çelik Sanayi, İnşaat, MSW tesisleri sektöründe faaliyet göstermektedir.
                enerji santraline geri dönüşüm ve atık.<br />
                Üretim tesisi, toplam kapasitesi yılda yaklaşık 1/2 milyon ton olan iki sıcak haddeleme hattını içeriyor.<br />
                Mevcut ürün portföyü, düz formda çeşitli kaliteli çelik kaliteleri ve boyutlarından (5,5-40 mm) oluşmaktadır.
                otomotiv, enerji, makine mühendisliği gibi karmaşık endüstriyel uygulamalarda kullanılan nervürlü filmaşin ve çubuk
                yanı sıra inşaat.
              </div>
            </div>
            <div className='buttons'>
              <div className='row_buttons'>
                <div className='button'>
                  <div className='contents' onClick={() => navigation('/tr/wirerod')}>
                    <div className='buttons_img'>  
                    </div>
                    <hr />
                    <div className='buttons_title'>
                      FILMAŞIN
                    </div>
                  </div>
                </div>

                <div className='button2'>
                  <div className='contents' onClick={() => navigation('/tr/steelrebar')}>
                    <div className='buttons_img'>  
                    </div>
                    <hr />
                    <div className='buttons_title'>
                      ÇELIK İNŞAAT DEMIRI
                    </div>
                  </div>
                </div>
              </div>

              <div className='row_buttons'>
                <div className='button3'>
                  <div className='contents' onClick={() => navigation('/tr/standardgalvanizedwire')}>
                    <div className='buttons_img'>  
                    </div>
                    <hr />
                    <div className='buttons_title'>
                      STANDART GALVANİZ<br />
                      TEL
                    </div>
                  </div>
                </div>

                <div className='button4'>
                  <div className='contents' onClick={() => navigation('/tr/steelingot')}>
                    <div className='buttons_img'>  
                    </div>
                    <hr />
                    <div className='buttons_title'>
                      ÇELİK KÜLÇE ( KÜTÜK )
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
